import React from 'react'
import { Card } from '../ui/Card'

const dimensions = [
  {
    title: 'Ensino regular',
    icon: '📘',
    text: 'Problemas, operações, raciocínio lógico, mediação passo a passo e apoio visual para construção do conceito matemático.'
  },
  {
    title: 'Programação',
    icon: '💻',
    text: 'Sequências, padrões, blocos lógicos, decomposição de problemas e reforço de funções executivas em atividades guiadas.'
  },
  {
    title: 'Games',
    icon: '🎮',
    text: 'Missões com metas claras, feedback rápido, reforço positivo e mecânicas que ajudam motivação e permanência na tarefa.'
  }
]

export default function DimensionShowcase() {
  return (
    <section className="section-stack">
      <div className="section-title-wrap">
        <span className="eyebrow">Trilhas 3D</span>
        <h2>Uma mesma competência matemática aparece em formatos diferentes.</h2>
        <p>Isso ajuda a criança a generalizar aprendizagem sem cair na monotonia. Matemática sem susto, com lógica e afeto.</p>
      </div>
      <div className="grid cols-3">
        {dimensions.map((item) => (
          <Card key={item.title}>
            <div className="icon-bubble">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </Card>
        ))}
      </div>
    </section>
  )
}
